import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from './../user.service';
import { User, Role } from './../user.model';
import { BaseEntityListComponent } from './../base-entity-list.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent extends BaseEntityListComponent<User> {

  displayedColumns = ["displayName", "email", "roles", "link"];

  constructor(private userService: UserService, private dialog: MatDialog, private snackBar: MatSnackBar, ) {
    super(User, userService, snackBar);
  }

  edit(user: User) {
    // noop
  }

  toggleRole(user: User, role: Role) {
    if (user.hasRole(role)) {
      user.roles.splice(user.roles.indexOf(role), 1);
    } else {
      if (!user.roles) { user.roles = []; }
      user.roles.push(role);
    }
    this.save(user);
  }

}
